import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconAccountBalanceLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.75 16.25v-5c0-.213.072-.39.216-.534A.727.727 0 0 1 6.5 10.5c.213 0 .391.072.535.216a.727.727 0 0 1 .215.534v5a.73.73 0 0 1-.216.535A.726.726 0 0 1 6.5 17a.725.725 0 0 1-.534-.215.726.726 0 0 1-.216-.535Zm5.5 0v-5c0-.213.072-.39.216-.534A.727.727 0 0 1 12 10.5c.213 0 .391.072.534.216a.726.726 0 0 1 .216.534v5a.73.73 0 0 1-.216.535A.726.726 0 0 1 12 17a.725.725 0 0 1-.534-.215.727.727 0 0 1-.216-.535ZM3.52 20.5a.725.725 0 0 1-.535-.216.726.726 0 0 1-.216-.534c0-.213.072-.391.216-.535A.726.726 0 0 1 3.519 19h16.962c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534.726.726 0 0 1-.216.535.725.725 0 0 1-.534.215H3.519Zm13.23-4.25v-5c0-.213.072-.39.216-.534a.727.727 0 0 1 .534-.216c.213 0 .391.072.535.216a.726.726 0 0 1 .215.534v5a.73.73 0 0 1-.216.535.726.726 0 0 1-.534.215.726.726 0 0 1-.535-.215.727.727 0 0 1-.215-.535Zm3.77-7.75H3.41a.618.618 0 0 1-.454-.186.616.616 0 0 1-.187-.453v-.39a.58.58 0 0 1 .098-.337.75.75 0 0 1 .258-.23l8.08-3.954c.25-.12.515-.18.794-.18s.544.06.795.18l8.04 3.929a.71.71 0 0 1 .396.641v.271a.689.689 0 0 1-.71.709ZM6.314 7h11.37l-5.55-2.692a.339.339 0 0 0-.135-.03.33.33 0 0 0-.135.03L6.315 7Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconAccountBalanceLine;
